import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux';
import Moment from 'moment';
import * as $ from 'jquery';
import { orderPaymentUpdate, orderPaymentCreate, orderPaymentsLoad } from '../../../../redux/actions/order/orderPaymentActions';
import { orderLoad } from '../../../../redux/actions/order/orderActions';
import Alert from '../../../../itrust_common/components/Alert';
import SaleRefundList from './SaleRefundList';
import useStoreAllowedPaymentMethods from '../../../../other/helperHooks/useStoreAllowedPaymentMethods';

function RefundsButtonForm(props) {
  const { payments_by_type, order, paymentEditing, user, orderPaymentSaving } = props;
  const [activeTab, setActiveTab] = useState('make_refund')
  const dispatch = useDispatch()
  const AllowedPaymentMethods = useStoreAllowedPaymentMethods()
  // const ONLINE_REFUND_PAYMENT_MODES = AllowedPaymentMethods.filter(item => ['online', 'device', 'link'].includes(item.value))
  // const { sales, refunds } = payments.reduce(
  //   (acc, payment) => {
  //     if (payment.payment_type === 'sale') acc.sales.push(payment);
  //     if (payment.payment_type === 'refund') acc.refunds.push(payment);
  //     return acc;
  //   },
  //   { sales: [], refunds: [] }
  // );

  useEffect(() => {
    if (!paymentEditing) {
      $("#orderRefundForm-modal").modal('hide')
    }
  }, [paymentEditing])

  const handlePaymentSubmit = async (data) => {
    if (!data.amount && !data.date_update) {
      Alert.warning("Please enter amount.")
    }
    else {
      if (data.id)
        await dispatch(orderPaymentUpdate(order.id, data))
      else
        await dispatch(orderPaymentCreate(order.id, data))
      dispatch(orderLoad(order.id, { include: '*' }))
    }
  }

  const handlePaymentEditCancel = () => {
    $("#orderRefundForm-modal").modal('hide')
  }

  const onlineRefund = (payment) => {
    let data = {
      amount: payment.amount,
      orders_order_id: order.id,
      mode_of_payment: payment.mode_of_payment,
      payment_date: Moment(new Date()).format("YYYY/MM/DD"),
      payment_type: 'refund',
      staff_id: user.id,
      prior_authorization_number: order.prior_authorization_number,
      parent_payment_id: payment.id,
      order_payment_id: payment.id,
      online_payment_details: { payment_intent_id: payment.online_payment_details.payment_intent_id },
    }
    handlePaymentSubmit(data)
  }

  return (
    <div className="inner-modal">
      <div className="modal refund-modal" id="orderRefundForm-modal">
        <div className="modal-dialog">
          <div className="modal-content border-0 shadow">
            <div className="modal-header p-5 align-items-center">
              <h5 className="modal-title">Refund Payment Details</h5>
              <button type="button" className="btn btn-outline-primary mr-3" onClick={handlePaymentEditCancel}>
                Cancel
              </button>
            </div>
            <div className="modal-body p-0">
              <div className='d-flex align-items-center bg-light border-radius-6 pt-2'>
                <span className={`px-6 line-height-3 cursor-pointer border-bottom border-2 ${activeTab === 'make_refund' ? 'text-primary border-primary' : ''}`} onClick={() => setActiveTab('make_refund')}>
                  <span>Make Refund</span>
                </span>
                <span className={`px-6 line-height-3 cursor-pointer border-bottom border-2 ${activeTab === 'refund_details' ? 'text-primary border-primary' : ''}`} onClick={() => setActiveTab('refund_details')}>
                  <span>Refunded Details</span>
                </span>
              </div>
              {activeTab === 'make_refund' && <div>
                <h5 className='px-5 mt-5 mb-3'>Make Refund</h5>
                {/* Can Refund Records = payment_type = sale */}
                {paymentEditing?.id && <SaleRefundList type="refund" handlePaymentSubmit={handlePaymentSubmit} onlineRefund={onlineRefund} payments={payments_by_type.sales} orderPaymentSaving={orderPaymentSaving} AllowedPaymentMethods={AllowedPaymentMethods} makeRefundModule={true} />}
              </div>}
              {activeTab === 'refund_details' && <div>
                <h5 className='px-5 mt-5 mb-3'>Refunded Details</h5>
                {/* Refunded Records = payment_type = refund */}
                <SaleRefundList type="refund" handlePaymentSubmit={handlePaymentSubmit} onlineRefund={onlineRefund} payments={payments_by_type.refunds} orderPaymentSaving={orderPaymentSaving} AllowedPaymentMethods={AllowedPaymentMethods} noShowMakeRefund={true} />
              </div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { orderPayment, order, other, auth: { user } } = state
  return {
    user,
    activeTab: other.activeTab.refund,
    paymentEditing: orderPayment.editing,
    payments_by_type: orderPayment.payments_by_type,
    orderPaymentSaving: orderPayment.saving,
    order: order.order,
    saving: order.saving,
  }
}

export default connect(mapStateToProps)(RefundsButtonForm);
